const Locale = {
  close: 'Закрыть',

  backToMain: 'Вернуться на главную',

  login: {
    signin: 'Вход',
    signout: 'Выход',
    host: 'Алиас домена',
    // login: 'Логин или адрес почты',
    login: 'Логин',
    user: 'Имя пользователя',
    email: 'Адрес электронной почты',
    password: 'Пароль',
    passwordTwice: 'Пароль еще раз',

    signup: 'Регистрация',
    forgotPassword: 'Забыли пароль?',
    forgotPasswordText: 'Введите адрес электронной почты и следуйте инструкциям в полученном письме',
    forgotPasswordButtonText: 'Восстановить пароль',

    validations: {
      fieldCannotBeEmpty: 'Поле не может быть пустым',
      fieldIsNotEmail: 'Введите адрес электронной почты',
      passwordsNotEqual: 'Пароли не совпадают'
    }
  },
  serverIsNotAvailable: {
    title: 'Внимание',
    text: 'Нет связи с сервером по адресу',
    tryReconnectButtonText: 'Попробовать установить связь',
    logoutText: 'Если связь с сервером не будет установлена, то в целях безопасности <br> произведите Выход из системы'
  },

  welcomePage: {
    // title: 'Добрый день',
    // text: `Мы рады Вас приветствовать.<br>`
  },

  menu: {
    dashboard: 'Инфопанель'
  }
}

export default Locale



// WEBPACK FOOTER //
// ./src/locales/ru.js